module.exports = __webpack_public_path__ + "static/media/form-continue-button.08e88f18.png";